import React from 'react';
import WebhooksAccessLayout from '../../../components/WebhooksAccessLayout';
import { READ_WEBHOOK_EVENTS } from '../../../constants/webhookPermissions';

export default function EventsAccessLayout() {
  return <WebhooksAccessLayout title="Events" permission={READ_WEBHOOK_EVENTS} />;
}
